(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-klantreis"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var DURATION = window.matchMedia('(pointer: coarse)').matches ? 480 : 420;
    var ROLL = 18;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function boxFrames(answer, opening) {
      var full = { height: answer.scrollHeight + 'px', paddingBottom: getComputedStyle(answer).paddingBottom };
      var none = { height: '0px', paddingBottom: '0px' };
      return opening ? [none, full] : [full, none];
    }

    function rollFrames(opening) {
      var hidden = { transform: 'translateY(-' + ROLL + 'px)', opacity: 0 };
      var shown = { transform: 'translateY(0)', opacity: 1 };
      return opening ? [hidden, shown] : [shown, hidden];
    }

    function toggle(details) {
      var answer = details.querySelector('.llfaq__a');
      var body = answer && answer.querySelector('.llfaq__abody');
      if (!answer || !body || reduce.matches || !answer.animate) {
        details.open = !details.open;
        return;
      }
      if (details.dataset.animating) return;
      details.dataset.animating = 'true';
      var opening = !details.open;
      if (opening) details.open = true;
      var box = answer.animate(boxFrames(answer, opening), { duration: DURATION, easing: EASING });
      var roll = body.animate(rollFrames(opening), { duration: DURATION, easing: EASING });
      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        if (!opening) details.open = false;
        delete details.dataset.animating;
      }
      Promise.all([box.finished, roll.finished]).then(done, done);
      setTimeout(done, DURATION + 100);
    }

    document.querySelectorAll('.llfaq__q > summary').forEach(function (summary) {
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        toggle(summary.parentElement);
      });
    });

    function openFromHash() {
      var id = window.location.hash.slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target || !target.classList.contains('llfaq__q')) return;
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }

    window.addEventListener('hashchange', openFromHash);
    openFromHash();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-article"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.ll-article');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('details.ll-article-q').forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = d.querySelector('.ll-article-a');
      if (!summary || !body || reduce) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h = body.offsetHeight;
          var anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'cubic-bezier(0.22,1,0.36,1)' });
          body.style.overflow = 'hidden';
          anim.finished.then(function () { d.open = false; body.style.overflow = ''; });
        } else {
          d.open = true;
          var target = body.offsetHeight;
          body.style.overflow = 'hidden';
          var anim2 = body.animate([{ height: '0px', opacity: 0 }, { height: target + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(0.22,1,0.36,1)' });
          anim2.finished.then(function () { body.style.overflow = ''; });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-collection-leuningen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-collection-profiles]');
    if (!root) return;
    var STOCK_YES = root.dataset.stockYes;
    var STOCK_NO = root.dataset.stockNo;
    var chips = root.querySelectorAll('.ll-colp-chip');
    var cards = root.querySelectorAll('.ll-colp-card');

    function setCard(card, color) {
      var swatch = card.querySelector('.ll-colp-swatch[data-color="' + color + '"]');
      if (!swatch) return;
      card.querySelectorAll('.ll-colp-swatch').forEach(function (b) {
        b.setAttribute('aria-pressed', b === swatch ? 'true' : 'false');
      });
      card.querySelectorAll('.ll-colp-img').forEach(function (img) {
        img.hidden = img.dataset.color !== color;
      });
      card.querySelectorAll('[data-card-link]').forEach(function (a) { a.href = swatch.dataset.url; });
      var label = card.querySelector('[data-card-color]');
      if (label) label.textContent = swatch.dataset.label;
      var price = card.querySelector('[data-card-price]');
      if (price) price.textContent = swatch.dataset.price;
      var stock = card.querySelector('[data-card-stock]');
      if (stock) {
        stock.textContent = swatch.dataset.stock === '1' ? STOCK_YES : STOCK_NO;
        stock.classList.toggle('is-order', swatch.dataset.stock !== '1');
      }
    }

    function setChips(color) {
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.dataset.color === color ? 'true' : 'false');
      });
    }

    function setAll(color) {
      setChips(color);
      cards.forEach(function (card) { setCard(card, color); });
    }

    function resetAll() {
      setChips(root.dataset.collectionColor || null);
      cards.forEach(function (card) { setCard(card, card.dataset.defaultColor); });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.getAttribute('aria-pressed') === 'true') {
          resetAll();
        } else {
          setAll(chip.dataset.color);
        }
      });
    });
    root.querySelectorAll('.ll-colp-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        setCard(swatch.closest('.ll-colp-card'), swatch.dataset.color);
        setChips(null);
      });
    });

    var params = new URLSearchParams(window.location.search);
    var kleur = (params.get('kleur') || '').toLowerCase();
    var profiel = (params.get('profiel') || '').toLowerCase();
    if (root.querySelector('.ll-colp-chip[data-color="' + kleur + '"]')) {
      setAll(kleur);
    } else {
      resetAll();
    }
    if (profiel) {
      var card = root.querySelector('.ll-colp-card[data-profile="' + profiel + '"]');
      if (card) {
        card.classList.add('is-highlighted');
        requestAnimationFrame(function () { card.scrollIntoView({ block: 'center' }); });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var DURATION = window.matchMedia('(pointer: coarse)').matches ? 480 : 420;
    var ROLL = 18;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function boxFrames(answer, opening) {
      var full = { height: answer.scrollHeight + 'px', paddingBottom: getComputedStyle(answer).paddingBottom };
      var none = { height: '0px', paddingBottom: '0px' };
      return opening ? [none, full] : [full, none];
    }

    function rollFrames(opening) {
      var hidden = { transform: 'translateY(-' + ROLL + 'px)', opacity: 0 };
      var shown = { transform: 'translateY(0)', opacity: 1 };
      return opening ? [hidden, shown] : [shown, hidden];
    }

    function toggle(details) {
      var answer = details.querySelector('.ll-contact-q-answer');
      var body = answer && answer.querySelector('.ll-contact-q-body');
      if (!answer || !body || reduce.matches || !answer.animate) {
        details.open = !details.open;
        return;
      }
      if (details.dataset.animating) return;
      details.dataset.animating = 'true';
      var opening = !details.open;
      if (opening) details.open = true;
      var box = answer.animate(boxFrames(answer, opening), { duration: DURATION, easing: EASING });
      var roll = body.animate(rollFrames(opening), { duration: DURATION, easing: EASING });
      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        if (!opening) details.open = false;
        delete details.dataset.animating;
      }
      Promise.all([box.finished, roll.finished]).then(done, done);
      setTimeout(done, DURATION + 100);
    }

    document.querySelectorAll('.ll-contact-q > summary').forEach(function (summary) {
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        toggle(summary.parentElement);
      });
    });

    // Bevestiging na versturen: Shopify laadt de pagina opnieuw met ?contact_posted=true.
    var posted = /[?&]contact_posted=true/.test(window.location.search);
    var card = document.querySelector('[data-contact-card]');
    if (posted && card) {
      var success = card.querySelector('[data-contact-success]');
      if (!success) {
        var form = card.querySelector('form');
        success = document.createElement('div');
        success.className = 'll-contact-success';
        success.setAttribute('tabindex', '-1');
        success.setAttribute('data-contact-success', '');
        success.innerHTML = '<span class="ll-contact-success-icon" aria-hidden="true"></span>' +
          '<p class="ll-contact-success-title"></p><p class="ll-contact-success-text"></p>';
        success.querySelector('.ll-contact-success-title').textContent = card.dataset.successTitle || '';
        success.querySelector('.ll-contact-success-text').textContent = card.dataset.successText || '';
        if (form) form.replaceWith(success); else card.appendChild(success);
      }
      if (window.matchMedia('(max-width: 999px)').matches) {
        card.scrollIntoView({ block: 'start' });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
